import React from 'react';

function CertificationCard({ image, title, date }) {
  return (
    <div className="certification-card">
      <img src={image} alt={title} className="certification-card__image" />
      <p className="certification-card__title">{title}</p>
      <p className='certification-card__date'>Issued {date}</p>
    </div>
  );
}

export default CertificationCard;
